//new vue structure
import Vue from 'vue'
import vueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import Clipboard from 'v-clipboard'
//another styles
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
///


import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(VeeValidate)
Vue.use(Clipboard)

//2
Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: `
    <div id="app">
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js